var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2446 6.20948L13.3204 0.230183C12.7143 -0.293254 11.759 0.131672 11.759 0.944779V4.09417C5.43966 4.16652 0.428711 5.43304 0.428711 11.4218C0.428711 13.839 1.98588 16.2336 3.70715 17.4856C4.24427 17.8763 5.00978 17.3859 4.81173 16.7526C3.02784 11.0476 5.65785 9.53304 11.759 9.44527V12.904C11.759 13.7183 12.715 14.1414 13.3204 13.6186L20.2446 7.63868C20.6802 7.26249 20.6807 6.58618 20.2446 6.20948Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.e21f23b820df344d2f75519ef1a83220.svg";
export { ForwardRef as ReactComponent };